import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterMatzen() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-matzen-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-matzen-heading">WETTER</h1>
        </div>

        <Wetter ort="matzen" />
      </div>
    </div>
  );
}

export default WetterMatzen;
